import type { Component } from 'vue'
import { computed, ref } from 'vue'
import ExplainQueryAnalysisSearchBox from '../components/explain/explain-query-analysis/search-box.component.vue'
import ExplainSearchSearchBox from '../components/explain/explain-search/search-box.component.vue'
import { ExplainSectionEnum } from '../enums/explain-section.enum'
import { FeatureIdEnum } from '../enums/feature-id.enum'
import { ROUTER_CONSTS } from '../router/router.consts'

export interface ExplainSectionConfig {
  routeName: string
  searchBoxComponent: Component
  areAllFiltersMandatory: boolean
}

const sectionsConfig: Partial<Record<ExplainSectionEnum, ExplainSectionConfig>> = {
  [ExplainSectionEnum.SEARCH]: {
    routeName: ROUTER_CONSTS.routes[FeatureIdEnum.EXPLAIN].search,
    searchBoxComponent: ExplainSearchSearchBox,
    areAllFiltersMandatory: true,
  },
  [ExplainSectionEnum.QUERY_ANALYSIS]: {
    routeName: ROUTER_CONSTS.routes[FeatureIdEnum.EXPLAIN].queryAnalysis,
    searchBoxComponent: ExplainQueryAnalysisSearchBox,
    areAllFiltersMandatory: false,
  },
}

export function useExplainSectionsConfig(
  initialSectionId: ExplainSectionEnum = ExplainSectionEnum.SEARCH,
) {
  const currentSection = ref(initialSectionId)

  const currentSectionConfig = computed(() => {
    return sectionsConfig[currentSection.value]
  })

  function setCurrentSection(sectionId: ExplainSectionEnum) {
    currentSection.value = sectionId
  }

  return { currentSection, currentSectionConfig, setCurrentSection }
}
